import { Injectable } from '@angular/core';
import { NotificationModule } from '../notifications.types';
import { NotificationEntity } from '../store/notification.models';

const MODULE_ICON_MAP: Record<string, string> = {
    [NotificationModule.BOOKING]: 'ticket-03',
    [NotificationModule.SHOW]: 'ferris-wheel',
    [NotificationModule.VENUE]: 'castle-02',
    [NotificationModule.USER]: 'user-circle',
    [NotificationModule.EMPLOYEE]: 'user-check-01',
    [NotificationModule.FINANCES]: 'coins-01',
    [NotificationModule.LOCATION]: 'store-location-02',
    [NotificationModule.SQUARE]: 'store-01',
};

@Injectable({
    providedIn: 'root',
})
export class NotificationAdapterService {
    /**
     * Maps a single raw notification object from the API into a NotificationEntity,
     * enriching it with an icon based on its module.
     */
    adaptSingle(raw: any): NotificationEntity {
        const notification = raw?.notification ?? raw;
        return {
            ...notification,
            id: String(notification.id),
            icon: notification.icon ?? MODULE_ICON_MAP[notification.module] ?? 'help-square',
        };
    }

    /**
     * Maps an array of raw API items (each containing a `notification` wrapper)
     * into an array of NotificationEntity.
     */
    adaptAll(items: any[]): NotificationEntity[] {
        return items.map((item) => this.adaptSingle(item));
    }
}
